import "./PdtCatDetail.css";

import React, { useEffect, useRef, useState } from "react";
import {
  BrowserRouter as Router,
  // Switch,
  Routes,
  Route,
  Link,
  useParams
} from "react-router-dom";

import {getBkendUrl, getJsonPath, getRootUrl, getUploadFileUrl} from "../../consts";

import {regUses, usePdtCats, useRcd} from "../../axios_with_token";

import { useData } from "../../consts";
import { getPdtCatGrp, getSubPdtCats} from "../PdtCatList/PdtCatList";
import BSPagination from "../../input_types/BSPaginition/BSPaginition";
import PdtList from "../PdtList/PdtList";

// Params are placeholders in the URL that begin
// with a colon, like the `:id` param defined in
// the route in this example. A similar convention
// is used for matching dynamic segments in other
// popular web frameworks like Rails and Express.
// [] pdtCatId is passed in by params
export default function PdtCatDetail(props) {
  const {regUse, isLoading, DefaultLoading, hasError, DefaultError} = regUses();
  const params = useParams();
  // const [pdtCatData, setPdtCatData] = useState({});
  const [pdts, setPdts] = useState();
  const [pdtsCnt, setPdtsCnt] = useState(0);
  const [page, setPage] = useState(props.page||0);
  const [rcdsPerPage, setRcdsPerPage] = useState(10);
  const [showPageCnt, setShowPageCnt] = useState(5); //how many pages to be shown in pagination
  const [searchFilters, setSearchFilters] = useState();

  const refSearch = useRef();

  const {data:pdtCats} = regUse(usePdtCats());
  const {data:pdtCat} = regUse(useRcd('pdtCats', params.id));


  // get category group (all cats under this leaf)
  const {setCurrentPdtCat, currentPdtCat} = useData();

  const subPdtCats = getSubPdtCats(params.id, pdtCats);

  if(isLoading())return <DefaultLoading></DefaultLoading>;
  if(hasError())return <DefaultError></DefaultError>;

  const searchFor = Object.values(searchFilters||{}).join(" , ").trim();
  return <div className="container">
      <div className="row">
        <h1>{(currentPdtCat||{}).name}</h1>
      </div>
      <div className="row">
    </div>

    {/* pdts filter */}
    <div className="row">
      <div className="col-md-3">
        <div className="container p-3">

            {/* search */}
            <div className="col-md-5">
              <div className="input-group mb-3">
                <input  type="search" className="form-control" placeholder="keywords..."
                  aria-label="search products in category" aria-describedby="button-addon2"
                  onChange={evt=>{
                    if(!refSearch.current.value){
                      setSearchFilters({
                        'name': refSearch.current.value
                      });
                    }                    
                  }}
                  ref={refSearch}
                />
                <button className="btn btn-outline-secondary"
                  type="button"
                  onClick={evt=>{
                    if(refSearch.current.value){
                      setSearchFilters({
                        'name': refSearch.current.value
                      });
                    }else{
                      setSearchFilters({});
                    }
                    // refSearch.current.value = '';
                  }}
                >Search</button>
              </div>
            </div>

          <div className="row mb-3">
            <span>size</span>
            <select name="size" id="size" className="form-contol">
              <option>111</option>
              <option>222</option>
              <option>333</option>
            </select>
          </div>
          <div className="row">
            <span>color</span>
            <select name="size" id="size" className="form-contol">
              <option>111</option>
              <option>222</option>
              <option>333</option>
            </select>

          </div>
        </div>
      </div>

      {/* pdts list */}
      <div className="col-md-9 p-0 m-0">
          {/* <div className="row mb-5"> */}
            {/* <nav aria-label="breadcrumb">
              <ol className="breadcrumb">
                <li className="breadcrumb-item active" aria-current="page">Home</li>
                <li className="breadcrumb-item active" aria-current="page">Cateogry {params.id}</li>
              </ol>
            </nav> */}

            {/* <div className="container">
              <h1 className="text-body playfair-400">Cateogry {params.id}</h1>
              <p className="lead text-secondary">Category descrption </p>
              <a className="btn btn-primary" href="#">check for details now</a>


            </div> */}


          {/* </div> */}

          {/* <div className="row mb-3">
            <h3>products in the category ...</h3>
          </div> */}
          
          {/* pagination */}
          <div className="row">


            {/* <div className="col-md-3">
              <nav aria-label="..." className="pull-right">
                <ul className="pagination pagination-sm ">
                  <li className="page-item active" aria-current="page">
                    <span className="page-link">1</span>
                  </li>
                  <li className="page-item"><a className="page-link" href="#">2</a></li>
                  <li className="page-item"><a className="page-link" href="#">3</a></li>
                </ul>
              </nav>
            </div> */}

            {/* <nav aria-label="Page navigation example">
                <BSPagination 
                    page = {page}
                    showPageCnt = {showPageCnt}
                    rcdCnt = {pdtsCnt}
                    rcdsPerPage = {rcdsPerPage}

                    // chgPageTo = {chgPageTo}
                    // handleClickPage = {handleClickPage}
                />
            </nav>      */}

          </div>

          {/* pdt list */}
          <div>
            {/* pdt list */}
            <h5>products in this category ...</h5>
            <PdtList 
              pdts={pdts}
            />

            {/* sub categories */}
            <h5>sub categories</h5>
            {(subPdtCats.length>0)&&<div>
              {/* <h2 className="mt-5">sub categories</h2> */}
              <div className="row">
                {subPdtCats.map((subPdtCat, subPdtCatIdx)=>{
                  let subCatImgs = [];
                  try{
                    subCatImgs = JSON.parse(subPdtCat.images||'[]');
                  }catch(err){
                    console.error('[PdtCatDetail error]', err);
                  }
                  return <div 
                    key={`${subPdtCat.__id}-${subPdtCatIdx}`}
                    className=" col-3"
                  >
                    <div className="card box-shadow m-1">
                        <div  className="card-img-top" 
                        
                          style={{
                            minHeight:"5em",
                            "backgroundPosition": "center top",
                            "backgroundSize":"cover",
                            "backgroundImage":`url(${(subCatImgs[0]||{}).url})`
                          }} 
                        ></div>
                        {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                            <div className="card-body">
                                <h5>{subPdtCat.name}</h5>
                                <Link 
                                    className="btn btn-sm btn-primary me-1"
                                    to={`${rootUrl}/app2/pdtDetail/${(subPdtCat||{}).__id}`}
                                >detail</Link>
                            </div>
                    </div>
                  </div>;

                })}

              </div>
            </div>}
                                
            {/* other intrested products */}
            <div className="row mt-5 mb-3">
              <h5>Other products you may also like ...</h5>
            </div>
            <div className="row  mb-3">
                <div className="col-md-6">
                    <div className="card" style={{"width": "18rem"}}>
                        <div  className="card-img-top" style={{"height":"10em",  "backgroundPosition": "center top", "backgroundSize":"cover",
                            "backgroundImage":"url(https://m.media-amazon.com/images/I/71BjC+kueJL._US500_.jpg)"
                        }} ></div>
                        {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                            <div className="card-body">
                                <h5 className="card-title">Card title</h5>
                                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="#" className="btn btn-primary">Go somewhere</a>
                            </div>
                    </div>
                </div>

                <div className="col-md-6">
                    <div className="card" style={{"width": "18rem"}}>
                        <div  className="card-img-top" style={{"height":"10em",  "backgroundPosition": "center top", "backgroundSize":"cover",
                            "backgroundImage":"url(https://www.midj.com/images/uploads/blog/01-arredo-hotel-midj.jpg)"
                        }} ></div>
                        {/* <img src="https://www.marthastewart.com/thmb/XFay_tPSlk423zZVSxrPC8h9bqs=/1500x0/filters:no_upscale():max_bytes(150000):strip_icc()/HTH0149-HowtoFoldBathTowels-2-74522e8f13e44de1987dc814191dfacf.jpg" className="card-img-top" alt="..." /> */}
                            <div className="card-body">
                                <h5 className="card-title">Card title</h5>
                                <p className="card-text">Some quick example text to build on the card title and make up the bulk of the card's content.</p>
                                <a href="#" className="btn btn-primary">Go somewhere</a>
                            </div>
                    </div>
                </div>

            </div>
            
          </div>

      </div>
    </div>
    


  </div>
}

const rootUrl = getRootUrl();
// const jsonPath = getJsonPath();
// const bkendUrl = getBkendUrl();


function Child() {
  // We can use the `useParams` hook here to access
  // the dynamic pieces of the URL.
  let { id } = useParams();

  return (
    <div>
      <h3>ID: {id}</h3>
    </div>
  );
}
